import { create } from 'zustand';

export type DialogKind = 'alert' | 'confirm' | 'prompt';

export interface DialogOptions {
  title: string;
  message?: string;
  eyebrow?: string;
  tone?: 'default' | 'danger';
  confirmLabel?: string;
  cancelLabel?: string;
  inputLabel?: string;
  inputPlaceholder?: string;
  inputDefaultValue?: string;
  inputType?: 'text' | 'number' | 'email' | 'password';
}

interface DialogState {
  open: boolean;
  kind: DialogKind;
  options: DialogOptions;
  inputValue: string;
  resolve: ((value: string | boolean | null) => void) | null;
  show: (kind: DialogKind, options: DialogOptions) => Promise<string | boolean | null>;
  setInputValue: (v: string) => void;
  close: (value: string | boolean | null) => void;
}

export const useDialogStore = create<DialogState>((set) => ({
  open: false,
  kind: 'alert',
  options: { title: '' },
  inputValue: '',
  resolve: null,
  show: (kind, options) =>
    new Promise((resolve) => {
      set({
        open: true,
        kind,
        options,
        inputValue: options.inputDefaultValue ?? '',
        resolve,
      });
    }),
  setInputValue: (v) => set({ inputValue: v }),
  close: (value) =>
    set((state) => {
      state.resolve?.(value);
      return { open: false, resolve: null };
    }),
}));
